/**
 * Domain-based Configuration
 * Auto-detect domain and return appropriate config
 */

const DOMAIN_CONFIGS = {
    // UFG Expert Configuration
    'ufg.expert': {
        name: 'UFG Expert',
        domain: 'ufg.expert',
        xApplication: 'asia.ufg',
        source: 'ufg.expert',
        referralBaseUrl: 'https://ufeelgreat.com/c',
        shoppingBaseUrl: 'https://ufg.expert',
        isLive: true
    },
    // Shopping Unicity AE Configuration
    'shopping-unicity.ae': {
        name: 'Shopping Unicity AE',
        domain: 'shopping-unicity.ae',
        xApplication: 'asia.shopping-unicity',
        source: 'shopping-unicity.ae',
        referralBaseUrl: 'https://shopping-unicity.ae/c',
        shoppingBaseUrl: 'https://shopping-unicity.ae',
        isLive: true
    },
    // Development / Localhost Configuration
    'localhost': {
        name: 'Development',
        domain: 'localhost',
        xApplication: 'asia.ufg',
        source: 'ufg.expert',
        referralBaseUrl: 'https://ufeelgreat.com/c',
        shoppingBaseUrl: 'http://localhost:3000',
        isLive: false
    }
}

// Default config (fallback)
const DEFAULT_CONFIG = DOMAIN_CONFIGS['ufg.expert']

/**
 * Get current hostname
 */
const getHostname = () => {
    return window.location.hostname
}

/**
 * Find matching config based on hostname
 */
const findConfig = (hostname) => {
    // Exact match
    if (DOMAIN_CONFIGS[hostname]) {
        return DOMAIN_CONFIGS[hostname]
    }

    // Partial match (for subdomains)
    for (const domain of Object.keys(DOMAIN_CONFIGS)) {
        if (hostname.includes(domain)) {
            return DOMAIN_CONFIGS[domain]
        }
    }

    // Check for localhost
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
        return DOMAIN_CONFIGS['localhost']
    }

    return DEFAULT_CONFIG
}

/**
 * Get current domain config
 */
const getCurrentConfig = () => {
    const hostname = getHostname()
    return findConfig(hostname)
}

/**
 * Get X-Application header value with country code
 * @param {string} countryCode - 2-letter country code (e.g., 'TH', 'AE')
 */
const getXApplication = (countryCode) => {
    const config = getCurrentConfig()
    return `${config.xApplication}.${countryCode}`
}

/**
 * Get source string for tracking with country
 * @param {string} country - country path segment
 */
const getSource = (country) => {
    const config = getCurrentConfig()
    return `${config.source}/${country}`
}

/**
 * Get referral URL
 * @param {string} referralCode - referral code
 */
const getReferralUrl = (referralCode) => {
    const config = getCurrentConfig()
    return `${config.referralBaseUrl}/${referralCode}`
}

/**
 * Get shopping URL with country and referral
 * @param {string} countryCode - country code
 * @param {string} referralCode - referral code (optional)
 */
const getShoppingUrl = (countryCode, referralCode = '') => {
    const config = getCurrentConfig()
    const baseUrl = `${config.shoppingBaseUrl}/${countryCode.toLowerCase()}`
    return referralCode ? `${baseUrl}/${referralCode}` : baseUrl
}

/**
 * Check if current domain is live/production
 */
const isLiveDomain = () => {
    const config = getCurrentConfig()
    return config.isLive
}

/**
 * Get live domains list for ReCAPTCHA check
 */
const getLiveDomains = () => {
    return Object.keys(DOMAIN_CONFIGS).filter(domain => DOMAIN_CONFIGS[domain].isLive)
}

export const DomainConfig = {
    getCurrentConfig,
    getXApplication,
    getSource,
    getReferralUrl,
    getShoppingUrl,
    isLiveDomain,
    getLiveDomains,
    getHostname,
    DOMAIN_CONFIGS
}

export default DomainConfig

